import { createSlice } from "@reduxjs/toolkit";
import { initialAccessLogsState } from "./accessLogs.types";
import { LoadState } from "../../constants/enums";
import {
  fetchUserTimeline,
  fetchModuleUsage,
  fetchTopUsers,
  fetchSlowApis,
  fetchErrorRate,
  fetchBankingLogs,
} from "./accessLogsThunk";

const accessLogsSlice = createSlice({
  name: "accessLogs",
  initialState: initialAccessLogsState,
  reducers: {
    clearAccessLogsState: (state) => {
      state.userTimeline = { ...initialAccessLogsState.userTimeline };
      state.moduleUsage = { ...initialAccessLogsState.moduleUsage };
      state.topUsers = { ...initialAccessLogsState.topUsers };
      state.slowApis = { ...initialAccessLogsState.slowApis };
      state.errorRate = { ...initialAccessLogsState.errorRate };
      state.bankingLogs = { ...initialAccessLogsState.bankingLogs };
    },
  },
  extraReducers: (builder) => {
    // fetchUserTimeline
    builder.addCase(fetchUserTimeline.pending, (state) => {
      state.userTimeline.loading = LoadState.InProgress;
      state.userTimeline.list = [];
      state.userTimeline.error = null;
    });
    builder.addCase(fetchUserTimeline.fulfilled, (state, action) => {
      state.userTimeline.loading = LoadState.Loaded;
      state.userTimeline.list = action.payload.data;
      state.userTimeline.totalRecords = action.payload.totalRecords;
    });
    builder.addCase(fetchUserTimeline.rejected, (state, action) => {
      state.userTimeline.loading = LoadState.Failed;
      state.userTimeline.error = action.payload?.message || "An error occurred";
    });

    // fetchModuleUsage
    builder.addCase(fetchModuleUsage.pending, (state) => {
      state.moduleUsage.loading = LoadState.InProgress;
      state.moduleUsage.list = [];
      state.moduleUsage.error = null;
    });
    builder.addCase(fetchModuleUsage.fulfilled, (state, action) => {
      state.moduleUsage.loading = LoadState.Loaded;
      state.moduleUsage.list = action.payload.data;
      state.moduleUsage.totalRecords = action.payload.totalRecords;
    });
    builder.addCase(fetchModuleUsage.rejected, (state, action) => {
      state.moduleUsage.loading = LoadState.Failed;
      state.moduleUsage.error = action.payload?.message || "An error occurred";
    });

    // fetchTopUsers
    builder.addCase(fetchTopUsers.pending, (state) => {
      state.topUsers.loading = LoadState.InProgress;
      state.topUsers.list = [];
      state.topUsers.error = null;
    });
    builder.addCase(fetchTopUsers.fulfilled, (state, action) => {
      state.topUsers.loading = LoadState.Loaded;
      state.topUsers.list = action.payload.data;
      state.topUsers.totalRecords = action.payload.totalRecords;
    });
    builder.addCase(fetchTopUsers.rejected, (state, action) => {
      state.topUsers.loading = LoadState.Failed;
      state.topUsers.error = action.payload?.message || "An error occurred";
    });

    // fetchSlowApis
    builder.addCase(fetchSlowApis.pending, (state) => {
      state.slowApis.loading = LoadState.InProgress;
      state.slowApis.list = [];
      state.slowApis.error = null;
    });
    builder.addCase(fetchSlowApis.fulfilled, (state, action) => {
      state.slowApis.loading = LoadState.Loaded;
      state.slowApis.list = action.payload.data;
      state.slowApis.totalRecords = action.payload.totalRecords;
    });
    builder.addCase(fetchSlowApis.rejected, (state, action) => {
      state.slowApis.loading = LoadState.Failed;
      state.slowApis.error = action.payload?.message || "An error occurred";
    });

    // fetchErrorRate
    builder.addCase(fetchErrorRate.pending, (state) => {
      state.errorRate.loading = LoadState.InProgress;
      state.errorRate.list = [];
      state.errorRate.error = null;
    });
    builder.addCase(fetchErrorRate.fulfilled, (state, action) => {
      state.errorRate.loading = LoadState.Loaded;
      state.errorRate.list = action.payload.data;
      state.errorRate.totalRecords = action.payload.totalRecords;
    });
    builder.addCase(fetchErrorRate.rejected, (state, action) => {
      state.errorRate.loading = LoadState.Failed;
      state.errorRate.error = action.payload?.message || "An error occurred";
    });

    // fetchBankingLogs
    builder.addCase(fetchBankingLogs.pending, (state) => {
      state.bankingLogs.loading = LoadState.InProgress;
      state.bankingLogs.list = [];
      state.bankingLogs.error = null;
    });
    builder.addCase(fetchBankingLogs.fulfilled, (state, action) => {
      state.bankingLogs.loading = LoadState.Loaded;
      state.bankingLogs.list = action.payload.data;
      state.bankingLogs.totalRecords = action.payload.totalRecords;
    });
    builder.addCase(fetchBankingLogs.rejected, (state, action) => {
      state.bankingLogs.loading = LoadState.Failed;
      state.bankingLogs.error = action.payload?.message || "Unknown error";
    });
  },
});

export const { clearAccessLogsState } = accessLogsSlice.actions;
export const accessLogsReducer = accessLogsSlice.reducer;
